export const isString = (str) => typeof str === 'string'
